import React, { useContext } from 'react'
import cancel from "../../Assets/Images/cancel.svg"
import close from "../../Assets/Images/close.svg"
import { Button } from '@material-ui/core'
import ModalContext from '../../store/ModalContext'

const DeclineConfirmModal = () => {
  const modalCtx = useContext(ModalContext);

  const closeHandle = () => {
    modalCtx.closeModal();
  }

  return (
    <div className='decline-authorize-modal'>
      <img src={cancel} alt="" className="decline-icon" />
      <span className='decline-title'>Request Declined</span>
      <p className='decline-message'>You have declined the request to be an emergency contact for {modalCtx.details}</p>
      <Button className='decline-done-btn' variant='contained' fullWidth onClick={() => closeHandle()}>Done</Button>
    </div>
  )
}

export default DeclineConfirmModal